import styled from 'styled-components';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  background: ${({ theme }) => theme.color.noir};
  border: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x1spacePx}px`};
  margin: ${({ theme }) => `0px ${theme.x2spacePx}px -${theme.x1spacePx}px`};
  ${media.lgUp`
    margin: ${({ theme }) => `-${theme.x2spacePx}px 0px -${theme.x1spacePx}px`};
  `}
`;

export const Icon = styled(InformationSolid)`
  align-self: start;
  fill: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;
